module.exports = __webpack_public_path__ + "static/fungi-mobile-42283d7bf0c2cca225fa1396f7cd669d.svg";